import React from 'react';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { selectColor } from '@panel/commons/core/theme';
import { useTranslation } from 'react-i18next';
import { isBrasilSite } from '@panel/commons/helpers';
import { showAnonymousLeads } from '../../../helpers/showAnonymousLeads';
import SectionLayout from '../../SectionLayout';
import { Container, HeaderArea, Icon, TitleText, TooltipComponent, IconTooltip } from './styles';
import DonutChart from '../../DonutChart';
import TooltipHelper from '../../../assets/icons/tooltipHelper.svg';
import IconContact from '../../../assets/icons/leadsIcon.svg';
import EmptyStateCharts from '../../EmptyState';

const ContactChart = ({ data, device, isStatisticsByPosting, error, reloadDispatch }) => {
  const { t } = useTranslation();

  const tooltipComponentHeader = () => {
    return (
      <TooltipComponent lowHigh={isStatisticsByPosting && !isBrasilSite}>
        {t(`panel.estadisticas.contactsType.tooltip${isStatisticsByPosting ? '.singular' : ''}`)}
      </TooltipComponent>
    );
  };

  const getWidthSection = () => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '50%';
    return '32%';
  };

  return (
    <SectionLayout
      width={getWidthSection()}
      marginTop={device !== 'desktop' && 16}
      padding={device !== 'desktop' && 16}
    >
      <Container
        device={device}
        height={data && data.userStats && showAnonymousLeads(data.userStats, false) ? 350 : 327}
        data-tour-panel='estadisticas-contactsChart'
      >
        <HeaderArea data-panel='panel-estadisticas-contactsType-headerArea'>
          <Icon icon={IconContact} data-panel='panel-estadisticas-contactsType-icon' />
          <TitleText data-panel='panel-estadisticas-contactsType-title'>
            {t('panel.estadisticas.contactsType.title')}
          </TitleText>
          <SimpleTooltip
            offset={5}
            backgroundColor={selectColor('black')}
            isMobile={false}
            text={tooltipComponentHeader()}
            position='top-center'
            dataPanel='panel-estadisticas-contactsType-tooltip'
            allowPlacements='top-end'
            autoPlacements
          >
            <IconTooltip
              src={TooltipHelper}
              alt='tooltip-helper'
              width='16'
              height='16'
              data-panel='panel-estadisticas-contactsType-icon-tooltip'
            />
          </SimpleTooltip>
        </HeaderArea>
        {data && !error ? (
          <DonutChart device={device} data={data || ''} />
        ) : (
          <EmptyStateCharts callback={reloadDispatch} />
        )}
      </Container>
    </SectionLayout>
  );
};

export default ContactChart;
